Promise = require 'bluebird'
_ = require 'underscore'
assert = require 'lib/assert'

module.exports = class EventsMixin
  # Backbone 1.0.0 adds this method, but we aren't running Backbone 1.0.0, so
  # here's a shim for you.
  #
  # Actually, this behaves slightly different from Backbone's implementation.
  # Backbone's implementation will bind *each* event in events (assuming it's
  # a space-separated list) once -- so the callback can be invoked once for
  # each of them. This is stupid, so we don't do that. Hopefully it won't
  # matter. Please don't rely on that.
  listenToOnce: (model, events, callback) ->
    removeFn = null
    actualCallback = ->
      callback.apply(this, arguments)
      removeFn()
    removeFn = =>
      @stopListening model, events, actualCallback

    @listenTo model, events, actualCallback

  waitForId: (model, next) ->
    @waitForAttr model, 'id', next

  waitForAttr: (model, attr, next) ->
    if arguments.length != 3
      # see [WAITING] minifesto below
      throw new Error "Wrong number of arguments to waitForAttr"
    if (val = model.get(attr))?
      next val
    else
      @listenToOnce model, "change:#{ attr }", =>
        @waitForAttr model, attr, next
    return

  waitForAttrs: (model, attrs, next) ->
    if arguments.length != 3
      # see [WAITING] minifesto below
      throw new Error "Wrong number of arguments to waitForAttrs"

    attrValues = attrs.map (attr) =>
      new Promise (resolve) =>
        @waitForAttr model, attr, resolve

    Promise.all(attrValues)
    .then (values) ->
      _.object _.zip(attrs, values)
    .tap next
    .done()

# [WAITING]
#
# Hey friends! You probably came here because you tried to use waitForAttr
# and it exploded and now you're upset. Here's the skinny: waitForAttr is
# different now. It used to be:
#
#     model.waitForAttr('attr', callback)
#
# But it is now:
#
#     listener.waitForAttr(model, 'attr', callback)
#
# It's the same as switching from on to listenTo.



// WEBPACK FOOTER //
// ./app/scripts/lib/events-mixin.coffee